import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const OrderLogProvider = (props) => {
  const api = new API();
  const [orderLogList, setOrderLogList] = useState([]);
  const [orderLogListLoader, setOrderLogListLoader] = useState(false);
  const [orderLogListPagination, setOrderLogListPagination] = useState({
    page: 1,
    limit: 10,
    total: 0
  });

  const fetchOrderLogList = async (data) => {
    setOrderLogListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("orderlog/list", {
        page: data?.page || orderLogListPagination.page,
        limit: data?.limit || orderLogListPagination.limit,
        type: data?.type || ""
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setOrderLogList(res?.data?.data?.data || []);
          setOrderLogListPagination({
            page: res?.data?.data?.pagination?.page || 1,
            limit: res?.data?.data?.pagination?.limit || 10,
            total: res?.data?.data?.pagination?.total || 0
          });
        } else {
          setOrderLogList([]);
        }
        setOrderLogListLoader(false);
      }));
  }

  return (
    <Context.Provider value={{
      ...props,
      orderLogList,
      orderLogListLoader,
      orderLogListPagination,
      fetchOrderLogList
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default OrderLogProvider;
